<template>
  <div>
    <div class="mt-10" style="position:relative;height:110px;">
      <div
              ui-jp="easyPieChart"
              class="easyPieChart"
              ui-refresh="app.setting.color"
              data-redraw="true"
              :data-percent="getPercent"
              :ui-options="`{percent: ${getPercent}, lineWidth: 5, trackColor: '#f0f0f0', barColor: '#00c73c', scaleColor: 'transparent', size: 110, scaleLength: 0, lineCap: 'butt' }`"
      >
        <div class="text-success"> {{getPercent.toFixed(1)}}% </div>
        <canvas height="110" width="110"></canvas></div>
    </div>

    <p class="mt-30"> {{ title }} : <span class="text-danger">{{numerator}}</span>/{{denominator}} {{measure}}</p>

  </div>
</template>

<script>
  export default {
    props:{
      year : {
        type: Number
      },
      idc : {
        type: String
      },
      title: {
        type: String
      },
      denominator: {
        type : Number
      },
      numerator : {
        type : Number
      },
      measure : {
        type: String
      }
    },
    computed : {
      getPercent() {
        if(this.denominator == 0) return 0.00;
        return 100 * this.numerator / this.denominator;
      },
    },
    mounted(){
      $(function() {
        $('.easyPieChart').easyPieChart({lineWidth: 5, trackColor: '#f0f0f0', barColor: '#00c73c', scaleColor: 'transparent', size: 110, scaleLength: 0, lineCap: 'butt' });
      });
    },
    methods: {

    }
  }
</script>

<style>

</style>
